/**
 * Extracts the pathname from document.referrer.
 * Returns an empty string if referrer is unavailable or invalid.
 */
const getReferrerPathname = (): string => {
  try {
    return new URL(document.referrer).pathname;
  } catch {
    return '';
  }
};

export default getReferrerPathname;
